
import React from 'react';
import { CardTitle } from '@/components/ui/card';

interface TrackCardTitleProps {
  trackName: string | undefined;
  fileName: string;
}

const TrackCardTitle: React.FC<TrackCardTitleProps> = ({ trackName, fileName }) => {
  return (
    <CardTitle className="text-xl font-medium tracking-tight truncate">
      {trackName || fileName}
    </CardTitle>
  );
};

export default TrackCardTitle;
